module.exports = new __parcel__URL__("desc_2.3ee27001.png").toString();